import moment from "moment";
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as actionsStock from '../../../actions/stockAction';
import { BackButton, Button, Input, SelectResource, Title, Collapsible, Select } from '../../../components/UI/ComponentsUI';
import StockService from '../../../services/StockService';
import { onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import { configs, downloadFile, isNullOrEmpty, showMessageToastCustom, translate, convertToUppercase } from '../../../utils/util';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { getVision } from "../../../services/auth";
import SelectNew from "../../../components/UI/SelectNew";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import InputUI from "../../../components/UI/InputUI";

const Report = (props) => {
    const [filterSearch, setFilterSearch] = useState({
        area: props.filter?.area || '',
        partNumber: props.filter?.partNumber || '',
        printer: props.user?.printer,
        levels: [],
        oddEvenPosition: props.filter?.oddEvenPosition || '',
        physicalStatus: props.filter?.physicalStatus || '',
        logicalStatus: props.filter?.logicalStatus || ''
    })
    const [summary, setSummary] = useState([])
    const [stockData, setStockData] = useState([])
    const [dropLevel, setDropLevel] = useState([]);

    const physicalStatusList = [
        { value: translate('stock:physicalStatus_blocked'), label: translate('stock:physicalStatus_blocked') },
        { value: translate('stock:logicalStatus_available'), label: translate('stock:logicalStatus_available') },
        { value: translate('stock:physicalStatus_entry'), label: translate('stock:physicalStatus_entry') },
        { value: translate('stock:physicalStatus_reserved'), label: translate('stock:physicalStatus_reserved') }
    ];

    const logicalStatusList = [
        { value: translate('stock:logicalStatus_qualityControl'), label: translate('stock:logicalStatus_qualityControl') },
        { value: translate('stock:logicalStatus_available'), label: translate('stock:logicalStatus_available') },
        { value: translate('stock:logicalStatus_movement'), label: translate('stock:logicalStatus_movement') },
        { value: `${translate('stock:logicalStatus_notConform')},NÂO CONSISTENTE`, label: translate('stock:logicalStatus_notConform') },
        { value: translate('stock:logicalStatus_notUsed'), label: translate('stock:logicalStatus_notUsed') },
        { value: translate('stock:logicalStatus_return'), label: translate('stock:logicalStatus_return') },
        { value: translate('stock:logicalStatus_scrpnf'), label: translate('stock:logicalStatus_scrpnf') },
        { value: translate('stock:logicalStatus_wipexp'), label: translate('stock:logicalStatus_wipexp') }
    ];

    useEffect(() => {
        var drop = [];
        for (let index = 1; index <= 12; index += 1) {
            var value = index.toString().length === 1 ? `0${index}` : index.toString()
            drop.push({ id: value, text: value })

        }
        setDropLevel(drop);
        // eslint-disable-next-line
    }, []);

    const onChangeResource = (el) => {
        if (!isNullOrEmpty(el.target.value)) {
            let resource = props.resources.find((i) => i.resourceId === parseInt(el.target.value));
            if (resource?.printer) {
                props.setResourceStock(resource);
            }
        }
        else {
            props.setResourceStock({});
        }
    }

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const validateRequest = () => {
        let areasConfig = configs(ENUMS.eModules.WarehouseManagement.value, props.config?.items)?.areasReportQueue;

        if (filterSearch.area.length === 0 && filterSearch.partNumber.length === 0) {
            showMessageToastCustom(translate('general:warning'), translate('stock:validationReport'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        if (!isNullOrEmpty(areasConfig) && !areasConfig.toUpperCase().includes(filterSearch.area.toUpperCase())) {
            if (filterSearch.area.length > 0 && filterSearch.area.split('.').length < 3) {
                showMessageToastCustom(translate('general:warning'), translate('stock:validationArea'), 3000, 'mdi mdi-alert-circle-outline red-text');
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }

    const validadeResource = () => {
        if (props.resourceStock == null) {
            showMessageToastCustom(translate('general:warning'), translate('stock:validationResource'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }
        else {
            return true;
        }
    }

    const downloadReport = () => {
        if (validateInputsRequired('formInput') && validateRequest()) {
            props.getReportArea(filterSearch, (data) => {
                if (data && data?.length > 0) {
                    downloadFile(data, `report_${filterSearch.area}.pdf`, "data:application/pdf", true);
                }
            });
        }
    }

    const searchSummary = () => {
        if (validateInputsRequired('formInput') && validateRequest()) {
            filterSearch.groupByAreaStreet = (getVision() === VISIONS.Jeep);
            props.getSummary(filterSearch, (data) => {
                if (data) {
                    setSummary(data.itemSummary);
                    setStockData(data.items);
                }
                else {
                    setSummary([]);
                    setStockData([]);
                }
            });
        }
    }

    const printReport = () => {
        if (validadeResource() && validateRequest()) {
            filterSearch.printer = props.user?.printer
            props.sendPrintReportArea(filterSearch);
        }
    }

    const printSummaryReport = () => {
        props.generateCsv(summary, (response) => {
            downloadFile(response, `${translate('summary-archive-name', 'stock')}FILA.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true)
        });
    }

    const exportExcel = () => {
        const dataExport = stockData.map((item) => ({
            DESENHO: item.partNumberCode,
            DESCRICAO: item.partNumberDescription,
            FORN: item.supplier,
            STATUS_FISICO: item.physicalStatus,
            STATUS_LOGICO: item.logicalStatus,
            QTD: item.qtd,
            CIM: item.cim,
            LOCAL: item.location,
            DESTINO: item.locationTarget,
            OBS: item.observation
        }));
        const ws = XLSX.utils.json_to_sheet(dataExport);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.shee;charset=UTF-8' });
        FileSaver.saveAs(data, 'Report-line.xlsx');
    }

    const addQueueFilter = (item) => {
        const selectedOptions = item.currentTarget.selectedOptions;
        if (selectedOptions.length > 0) {
            let finalFilter = {};
            Object.assign(finalFilter, filterSearch);
            finalFilter.levels = Array.from(selectedOptions).map(x => x.value)
            setFilterSearch(finalFilter);
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <Title label={translate('change-location:fila-report')} />
            <div className="container" >
                <Collapsible
                    id="collapsible"
                    header={translate('stock:filter')}
                    body={
                        <>
                            <div id="formInput" className="row no-margin-bottom">
                                <div className="row">
                                    <div className="input-field no-padding col s6 m6 l6">
                                        <Input
                                            id="area"
                                            name='area'
                                            label={translate('stock:area')}
                                            type="text"
                                            maxlength={19}
                                            defaultValue={filterSearch.area || ''}
                                            onKeyUp={convertToUppercase}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5 m5 l5">
                                        <InputUI
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('stock:partnumber')}
                                            type="text"
                                            numericonly="true"
                                            maxlength={11}
                                            defaultValue={filterSearch.partNumber || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    {getVision() === VISIONS.Jeep && (
                                        <>

                                            <div className="input-field no-padding col s6 m6 l6" style={{ marginTop: 0 }}>
                                                <Select
                                                    id="levels"
                                                    name="levels"
                                                    label="Nivel"
                                                    display="description"
                                                    change={addQueueFilter}
                                                    multiple={true}
                                                    changeAll={() => {
                                                        filterSearch.levels = dropLevel.map((f) => f.id);
                                                        setFilterSearch({ ...filterSearch });
                                                    }}
                                                    placeHolder="Selecione um Nivel"
                                                    disablePlaceHoderSelect={true}
                                                    data={dropLevel}
                                                    clearAll={() => {
                                                        filterSearch.levels = [];
                                                        setFilterSearch({ ...filterSearch });
                                                    }}
                                                />
                                            </div>
                                            <div className="input-field no-padding col s5 m5 l5" style={{ marginTop: 0 }}>
                                                <SelectNew
                                                    id="oddEvenPosition"
                                                    name='oddEvenPosition'
                                                    valuefield="value"
                                                    display="label"
                                                    value={filterSearch.oddEvenPosition || ''}
                                                    label="Lado"
                                                    placeHolder={translate('stock:oddEvenPositionBoth')}
                                                    data={[{ value: '1', label: translate('stock:odd') }, { value: '0', label: translate('stock:pair') }]}
                                                    change={onChange}
                                                />
                                            </div>

                                            <div className="input-field no-padding col s6 m6 l6">
                                                <SelectNew
                                                    id="physicalStatus"
                                                    name='physicalStatus'
                                                    valuefield="value"
                                                    display="label"
                                                    label={translate('stock:physicalStatus')}
                                                    value={filterSearch.physicalStatus || ''}
                                                    data={physicalStatusList}
                                                    change={onChange}
                                                />
                                            </div>

                                            <div className="input-field no-padding col s5 m5 l5">
                                                <SelectNew
                                                    id="logicalStatus"
                                                    name='logicalStatus'
                                                    valuefield="value"
                                                    display="label"
                                                    label={translate('stock:logicalStatus')}
                                                    value={filterSearch.logicalStatus || ''}
                                                    data={logicalStatusList}
                                                    change={onChange}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="no-padding col s12">
                                    <SelectResource
                                        printLaser
                                        name="resource"
                                        id="resource"
                                        value={props.resourceStock.resourceId || props.user?.resourceLaser}
                                        onChange={onChangeResource} />
                                </div>
                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <Button
                                    full="true"
                                    className="col s6 btn-principal"
                                    text={translate('general:search')}
                                    onClick={searchSummary}
                                />
                            </div>
                        </>
                    }
                />
                {summary?.length > 0 &&
                    <div className="row">
                        <div className="card col s12">
                            <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <b>{translate('stock:queue-summary')}</b>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                    <b className="sixth-text-color mt-15 col s12 m6" style={{ display: 'block' }}>{translate('menu.user', 'configuration')}: {props.user?.userName} - {props.user.name?.toUpperCase()}</b>
                                    <b className="sixth-text-color mt-15 col s12 m6" style={{ display: 'block' }}>{moment().format('DD/MM/yyyy hh:mm')}</b>
                                </div>
                                <div className="row">
                                    {summary?.map((item, index) => {
                                        return (
                                            <b className="sixth-text-color block col s12 m6" key={index} style={{ display: 'block' }}>{item.location} - {item.quantity} {translate('stock:positions')}</b>
                                        );
                                    })}
                                </div>
                                <div className="row">
                                    <div className="col s12 mt-15" >
                                        {getVision() === VISIONS.Jeep ? (
                                            <Button
                                                full="true"
                                                className="col s6 btn-principal"
                                                text={translate('stock:download-excel')}
                                                onClick={exportExcel}
                                            />
                                        ) : (
                                            <Button
                                                full="true"
                                                className="col s6 btn-principal"
                                                text={translate('stock:download-summary')}
                                                onClick={printSummaryReport}
                                            />
                                        )}
                                    </div>
                                    <div className="col s12 mt-15">
                                        <Button
                                            full="true"
                                            className="col s6 btn-principal"
                                            text={translate('general:generateReport')}
                                            onClick={downloadReport}
                                        />
                                    </div>
                                    {
                                        props.user?.printer && props.user?.printer.laser &&
                                        <div className="col s12 mt-15">
                                            <Button
                                                full="true"
                                                className="col s6 btn-principal"
                                                text={translate('stock:print-report')}
                                                onClick={printReport}
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        materials: state.stockReducer.materials,
        filter: state.stockReducer.filter,
        resourceStock: state.stockReducer.resourceStock,
        resources: state.logisticsResourceReducer.list,
        config: state.configReducer.config,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReportArea: (filter, callback) => {
            dispatch(StockService.getReportArea(filter, callback));
        },
        setResourceStock: (resourceStock) => {
            dispatch(actionsStock.setResourceStock(resourceStock));
        },
        sendPrintReportArea: (filter, callback) => {
            dispatch(StockService.sendPrintReportArea(filter, callback));
        },
        getSummary: (filter, callback) => {
            dispatch(StockService.getSummary(filter, callback));
        },
        generateCsv: (filter, callback) => {
            dispatch(StockService.generateCsv(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Report));